import React, { useState } from 'react';
import styles from '../../builder.module.scss';
import Switcher from '../../../bitaComponents/Switcher/Switcher';
import { ComponentGenerator } from '../Components';

export const BuilderToggleGroup = ({
  setterFunction = Function.prototype,
  setterFilter = Function.prototype,
  filterField = '',
  onChange = Function.prototype,
  path,
  options = [],
  id = '',
  widgetData,
  subcomponents_direction,
  disabled = false,
  default_option = false,
  styling,
  hidden,
}) => {
  const [selected, setSelected] = useState(
    default_option ? Object.values(options).filter(i => i.title === default_option)[0] : '',
  );
  React.useEffect(() => {
    /**
     * The next condition is to check default toggle
     */
    if (typeof options[0] === 'object') {
      Object.values(options).forEach(option => option.toggled_by_default && setSelected(option));
    }
    if (widgetData && widgetData[id]) {
      if (typeof options[0] === 'object') {
        const searchWidget = () => {
          if (
            widgetData[id] === 'Perform Extraordinary Reconstitution' ||
            widgetData[id] === 'Same Weight'
          ) {
            return 'Simultaneous to Event';
          }
          return widgetData[id];
        };
        const dataSelected = Object.values(options).filter(
          option => option.title === searchWidget(),
        );

        setSelected(dataSelected[0]);
      } else {
        setSelected(widgetData[id]);
      }
    }
  }, []);

  const localPath = path ? `${path}.${id}` : id;
  React.useEffect(() => {
    if (setterFilter && setterFunction) {
      if (selected && selected.length > 0)
        setterFunction(prev => ({ ...prev, RadioGroup: selected }));
      if (setterFilter) setterFilter(prev => ({ field: filterField, filter: selected }));
    }
    if (onChange && selected)
      onChange(selected.id ? `${localPath}.${selected.id}` : localPath, selected.title);
    return () => {
      if (selected && selected.onclick && typeof selected.onclick[0] === 'object') {
        Object.values(selected.onclick).forEach(comp => {
          if (comp.id) {
            onChange(`${path}.${comp.id}`, undefined);
          }
        });
      } else if (selected && selected.onclick && selected.onclick.id) {
        onChange(`${path}.${selected.onclick.id}`, undefined);
      }
    };
  }, [selected]);

  if (typeof options[0] === 'object') {
    return (
      <div
        className={`${styles.radioParentGroup} builderToggleGroup`}
        style={{
          opacity: disabled ? (hidden ? '0' : '0.5') : '1',
          pointerEvents: disabled ? 'none' : '',
          flexFlow: subcomponents_direction === 'horizontal' ? 'row' : 'column',
        }}
      >
        {Object.values(options).map(option => (
          <div key={option.title}>
            <div
              className={`${styles.radioHolder} radioHolder `}
              style={
                subcomponents_direction === 'horizontal'
                  ? {
                      minWidth: 250,
                      marginRight: 30,
                      width: 'auto',
                      opacity: option.disabled ? '0.5' : '1',
                      pointerEvents: option.disabled ? 'none' : '',
                    }
                  : {
                      opacity: option.disabled ? '0.5' : '1',
                      pointerEvents: option.disabled ? 'none' : '',
                    }
              }
            >
              <span>{option.title}</span>
              <Switcher.Switch
                className={`${styles.customRadio} builderToggleSwitcher `}
                onChange={() => {
                  // eslint-disable-next-line no-unused-expressions
                  id === 'value_default_nro_constituents'
                    ? onChange(localPath, option, '')
                    : onChange(path, {});
                  if (option !== selected) {
                    setSelected(option);
                  } else {
                    setSelected('');
                    // eslint-disable-next-line no-unused-expressions
                    id === 'value_default_nro_constituents'
                      ? onChange(localPath, false, '')
                      : onChange(false, undefined, undefined, id);
                  }
                }}
                checked={
                  id === 'value_default_nro_constituents'
                    ? !(option === selected)
                    : option === selected
                }
              />
              {option?.post_text && (
                <span
                  style={{
                    minWidth: id === 'value_default_nro_constituents' ? '140px' : '',
                    marginLeft: id === 'value_default_nro_constituents' ? '10px' : '',
                  }}
                >
                  {option?.post_text}
                </span>
              )}
            </div>
            {selected && option.title === selected.title && option.onclick && (
              <div
                className={`${
                  styling === 'structured' ? styles.structuredWidget : styles.builderRadioGroup
                } builderRadioGroup `}
                style={option.options_text ? { flexDirection: 'column' } : {}}
              >
                {option.options_text && <span>{option.options_text}</span>}
                {typeof option.onclick[0] === 'object' ? (
                  Object.values(option.onclick).map((comp, index) => (
                    <ComponentGenerator
                      {...comp}
                      path={path}
                      onChange={onChange}
                      widgetData={widgetData}
                      key={index + comp.toString()}
                    />
                  ))
                ) : (
                  <ComponentGenerator
                    {...option.onclick}
                    path={path}
                    onChange={onChange}
                    widgetData={widgetData}
                  />
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }

  return Object.values(options).map(option => (
    <div key={option}>
      <div className={`${styles.radioHolder} radioHolder `}>
        <span>{option}</span>
        <Switcher.Switch
          key={option}
          className={styles.customRadio}
          onChange={() => (option === selected ? setSelected('') : setSelected(option))}
          checked={option === selected}
        />
      </div>
    </div>
  ));
};
